export default {"src":"/_next/static/media/0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e.ccfaf818.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};